import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Laverage(props) {
  return (
    <div className="laverage_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Our Process to Custom Software Development Success</h2>
            <p>
              Our team of software developers in Miami provides personalized
              solutions that meet your precise business needs. As one of Miami’s
              software development companies, we understand that each firm has
              its own organizational structure; therefore, we customize our
              approaches to align with their operational procedures, resulting
              in the creation of personalized and faultless software.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>Ideation</h6>
                <p>Conducting Product Discovery and Product Research</p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>Design</h6>
                <p>Creating the UX Design, UI Design, and Branding</p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>Development</h6>
                <p>Developing the software with our seasoned engineers</p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>Quality Assurance</h6>
                <p>
                  Testing the software and making sure that everything works
                  well
                </p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>Maintenance & Support</h6>
                <p>Co-managing the software with your technology team</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
